<ng-container *ngIf="!modalOptions?.onLoad">
  <mapfre-button
    [additionalClasses]="modalOptions?.additionalButtonClasses"
    [buttonCopy]="modalOptions?.buttonCopy || buttonString"
    [howManyIconsUsed]="modalOptions?.howManyIconsUsed"
    [inputType]="'modal'"
    [iconClasses]="modalOptions?.iconClasses"
    [iconFamily]="modalOptions?.iconFamily"
    [modalId]="modalOptions?.modalId"
    [screenReader]="modalOptions?.screenReader"
    [showIcons]="modalOptions?.showIcons"
    [customIcon]="modalOptions?.customIcon"
    [showIconsCustom]="modalOptions?.showIconsCustom"
    [showUserName]="modalOptions?.modalTranslateCopy"
    [disabledValue]="disabledValue"
    (click)="showModal(); onOpenModalClick(); whereIsTheHelpButton($event)">
  </mapfre-button>
</ng-container>

<div *ngIf="isModalVisible" class="modal-backdrop fade show" (click)="hide()"></div>

<div
  [class.show]="isModalVisible"
  [style.display]="isModalVisible ? 'block' : 'none'"
  [attr.aria-hidden]="!isModalVisible"
  (click)="$event.target === $event.currentTarget && hide()"
  class="modal fade {{modalOptions?.animatePosition}}" 
  tabindex="-1" 
  role="dialog" 
  [id]="modalOptions?.modalId" 
  >

  <div
    role="document"
    class="{{modalOptions?.additionalClasses}} {{size}} {{modalTypeClasses}} modal-dialog-scrollable"
    [style.left]="helpButtonPositionLeft"
    >
      <div class="modal-content"
        [ngClass]="{'no-margin-bottom': modalOptions?.typeOfModal === 'wallet'}"
      >
        <!-- Regular Version --> 
        <ng-container *ngIf="modalOptions?.typeOfModal !== 'wallet' || modalOptions?.typeOfModal !== 'address confirmation ma'">
          <div class="modal-header">
            <h4 class="modal-title w-100 {{modalOptions?.additionalHeaderClasses}}" id="{{modalOptions?.typeOfModal}}">
              <ng-container *ngIf="modalOptions?.headerIconClass !== ''">
                <mapfre-icon 
                  [iconClasses]="modalOptions?.headerIconClass" 
                  [iconFamily]="modalOptions?.iconFamily">
                </mapfre-icon>
              </ng-container>
              {{ modalOptions?.modalTranslateCopy | translate }}
            </h4>
            <ng-container *ngIf="modalOptions?.modalName === 'header_Account'; else otherModalsCloseBtn">
              <button type="button" class="close account-up-arrow" data-dismiss="modal" aria-label="Close"
               (click)="hide(); onClickCloseModal();" [ngClass]="{'close-button-mr':(isAcmic && loggedinHeaderModal)}">
               <img src="assets/SVG/account-up-arrow.svg"/>              
              </button>
            </ng-container>
            <ng-template #otherModalsCloseBtn>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close"
               (click)="hide(); onClickCloseModal();" [ngClass]="{'close-button-mr':(isAcmic && loggedinHeaderModal)}">
                  <img src={{closeIcon}}/>              
              </button>
            </ng-template>
          </div>
        </ng-container>
        <!-- /Regular Version --> 
        <ng-content></ng-content>
    </div>
  </div>
</div>